<!-- Card -->
<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'general.organizeBookings' | translate }}
    </h3>
  </div>
  <!-- End Header -->
  <!-- Body -->

  <div class="card-body text-center" *ngIf="isLoading$ | async">
    <div
      *ngIf="isLoading$ | async"
      class="spinner-border"
      role="status"
      attr.aria-label="{{ 'general.loading' | translate }}"
    >
    </div>
  </div>

  <div *ngIf="!(isLoading$ | async)">
    <organize-bookings
      *ngIf="(productGroups$ | async).length"
      [productGroups]="productGroups$ | async"
      [saleId]="saleId$ | async"
    ></organize-bookings>
  </div>
  <!-- End Body -->
</section>
<!-- End Card -->
